import { enableProdMode, InjectionToken } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { APP_BASE_HREF, PlatformLocation } from '@angular/common';

export const AntiForgeryToken = new InjectionToken<string>("AntiForgeryToken");


export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
 
export function getReportingBaseUrl() {
  return document.getElementsByTagName('eve-reporting-url')[0].attributes.getNamedItem('value')?.value ?? "";
}

export function getAntiForgeryToken() {
  return document.getElementsByTagName('anti-forgery-token')[0]?.attributes?.getNamedItem('value')?.value ?? "";
}

const providers = [
  { provide: 'BASE_REPORTING', useFactory: getReportingBaseUrl, deps: [] },
  { provide: AntiForgeryToken, useFactory: getAntiForgeryToken, deps: [] },
  {
    provide: APP_BASE_HREF,
    useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
    deps: [PlatformLocation]
  }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));


// platformBrowserDynamic(providers).bootstrapModule(AppModule)
//   .catch(err => console.log(err));

